/* eslint global-require: "off", import/no-dynamic-require: "off" */
import path from 'path';

const rendererNames = [
  'vBulletin-default',
];

const renderers = {};

rendererNames.forEach((name) => {
  renderers[name] = require(path.join(__dirname, name)).default;
});

export default renderers;
